// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import TomSelect from 'tom-select/dist/js/tom-select.complete.js'

up.compiler('.searchable-select', (element) => {
  const tomSelect = new TomSelect(element, {})

  return function() {
    tomSelect.destroy()
  }
})
